// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1y_tj","bigColWidth":"Table_bigColWidth__1VqNr","biggerColWidth":"Table_biggerColWidth__24Srs","row":"Table_row__VswCY","col":"Table_col__2eUNQ"};